var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(async () => {
  GorgiasChat.hidePoweredBy(true)
})

// open gorgias chat from link
try {
  const contactbutton = document.querySelectorAll('a[href*="#?gs_open_chat"]')
  contactbutton[0].addEventListener('click', () => {
    GorgiasChat.open();
  });
} catch (error) {
	console.log ("no gorgias chat link found:", error)
}

// open external links in a new tab
document.addEventListener('DOMContentLoaded', function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && links[i].hostname !== 'kybun.swiss') {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}, false);